import React from 'react';
import { FadeIn } from './FadeIn';
import { XIcon, CheckIcon } from 'lucide-react';
export function BeforeAfter() {
  const before = ['Improvisás cada consulta clínica sin un sistema claro', 'Perdés horas buscando información en papers sueltos', 'Te sentís inseguro/a frente a patologías complejas', 'Cobrás poco porque no podés justificar un abordaje premium', 'El seguimiento de pacientes es caótico y sin estructura', 'Sentís que la facultad no te preparó para la realidad clínica'];
  const after = ['Tenés protocolos listos para cada patología desde el día 1', 'Todo organizado en 6 tomos clínicos de consulta rápida', 'Abordás casos complejos con seguridad y criterio profesional', 'Cobrás lo que vale tu trabajo con un sistema que lo respalda', 'Seguimiento estructurado que fideliza y genera resultados', 'Arrancás cada consulta con confianza y respaldo clínico real'];
  return <section className="py-8 px-3" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <FadeIn className="text-center mb-6" data-id="element-18">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-19">
            Antes vs Después del{' '}
            <span className="text-accent" data-id="element-20">MegaPack Pro</span>
          </h2>
          <p className="text-sm text-white/50" data-id="element-21">
            El cambio que experimentan los nutricionistas que lo implementan
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-22">
          {/* ANTES */}
          <FadeIn delay={0.1} data-id="element-23">
            <div className="bg-red-500/5 border border-red-500/20 rounded-xl p-5 h-full" data-id="element-24">
              <h3 className="text-lg font-bold text-red-400 mb-4 text-center uppercase tracking-wider" data-id="element-25">
                ❌ Antes
              </h3>
              <ul className="space-y-3" data-id="element-26">
                {before.map((item, idx) => <li key={idx} className="flex items-start gap-2.5" data-id="element-27">
                    <XIcon className="text-red-400 shrink-0 mt-0.5" size={16} data-id="element-28" />
                    <span className="text-sm text-white/70" data-id="element-29">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* DESPUÉS */}
          <FadeIn delay={0.2} data-id="element-30">
            <div className="bg-accent/5 border border-accent/25 rounded-xl p-5 h-full" data-id="element-31">
              <h3 className="text-lg font-bold text-accent mb-4 text-center uppercase tracking-wider" data-id="element-32">
                ✅ Después
              </h3>
              <ul className="space-y-3" data-id="element-33">
                {after.map((item, idx) => <li key={idx} className="flex items-start gap-2.5" data-id="element-34">
                    <CheckIcon className="text-accent shrink-0 mt-0.5" size={16} data-id="element-35" />
                    <span className="text-sm text-white/90 font-medium" data-id="element-36">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}